import styled from "styled-components";
import { Grid, Row, Label } from "react-bootstrap";

import { Title, CtaButton } from "../Common/index.style";
import { secondaryColor, primaryColor } from "../variables.styles";

export const Container = styled(Grid)`
  max-width: 900px;
  margin: 0 auto;
  padding: 3rem;
  margin-top: 10rem;
  font-size: 1.6rem;
`;

export const CheckoutTitle = styled(Title)``;

export const SubscriptionCycle = styled.div`
  text-align: center;
  text-transform: uppercase;

  a {
    color: #39b54a;
    text-decoration: none;
    border: 1px solid #39b54a;
    padding: 0.5em 1.5em;
    font-weight: bolder;
  }

  a:hover {
    color: white;
    background: green;
  }

  a:first-child {
    border-right: none;
    border-top-left-radius: 0.2em;
    border-bottom-left-radius: 0.2em;
  }

  a:nth-child(2) {
    border-top-right-radius: 0.2em;
    border-bottom-right-radius: 0.2em;
  }
`;

export const OrderButton = styled(CtaButton)`
  float: right;
  width: 150px;
  height: 40px;
  display: block;
  margin: 0 3rem 0 2rem;
`;

export const OrderDetailsContainer = styled(Row)`
  max-width: 400px;
  margin: 2rem auto 2rem auto;
  padding: 2rem;
  transform: translateX(10%);
`;

export const PlanRow = styled(Row)`
  text-transform: capitalize;
  i {
    color: #7b794a;
    font-size: 1.2rem;
  }
  &:after {
    content: "";
    display: block;
    height: 1px;
    background: #dcdcdc;
    width: 85%;
    margin: 3rem auto 2rem auto;
    border-radius: 1rem;
    transform: translateX(-10%);
  }
`;

export const SubscriptionLabel = styled(Label)`
  background: linear-gradient(to right, green 10%, ${secondaryColor});
`;

export const SwitchPlan = styled.a`
  border-bottom: 0 solid;
  transition: border-bottom 350ms linear;
  font-size: 1.2rem;
  font-weight: bolder;
  letter-spacing: 1.7;

  &:link,
  &:hover,
  &:visited {
    text-decoration: none;
    display: inline-block;
  }

  &:after {
    content: "";
    display: block;
    width: 0;
    height: 2px;
    background: ${secondaryColor};
    transition: width 350ms;
  }

  &:hover::after {
    width: 100%;
    background: ${primaryColor};
  }
`;
